import type { ApiFactory } from '~library/services'

export default class CommonAuthApi {
  constructor(private api: ApiFactory) {}

  /**
   * API 檔案下載
   * 檔案下載
   * https://hackmd.io/z604hpJ-TQuBmb4glcc3iA
   */
  downloadFile(fileId: string): Promise<void> {
    return this.api.downloadFile({
      method: 'GET',
      url: `Common/DownloadFile/${fileId}`
    })
  }
}
